//dependencies
import $ from "jquery";

export default function() {

    function initScript() {

        // Initial Load
        var $body = $("body");


        populateCalendar("");
        populateEvents("");

        $body.on("click","#calendarNext, #calendarPrevious", function() {
            var date = $(this).data("date");
            populateCalendar(date);
        });
		
        // Need to do this since content is dynamically generated.
        $body.on("click", ".calendarDayNumber", function() {
            var $this = $(this);
            var date = $this.data("date");

            var $td = $("#calendarData tr td");

            // Remove active state from everything else. 
            $.each($td, function( key, value ) {
                $(this).removeClass("active");
            });

            $this.closest("td").addClass("active");
            window.curry.date = date;
            populateEvents();
        });

        $("[id^=inlineCheckbox]").on("change", function () {
            populateEvents();
        });
    }

    function populateCalendar(date) {
        $.ajax({
            url: window.curry.calendarFeed,
            type: "GET",
            data: {
                Date: date
            },
            success: function (response) {
                $("#calendar").html(response);
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });

    }

    function populateEvents() {
        var topics = $("[id^=inlineCheckbox]:checked").map(function(){
            return $(this).val();
        }).get();


        $.ajax({
            type: "POST",
            url: window.curry.eventsCalendarFeed,
            data: {
                Date: window.curry.date,
                Topics: topics
            },
            success: function (response) {
                if (response !== "") {
                    $("#eventContent").html(response);
                    
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

 

    initScript();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/events.js